export const SET_COMPLETED_PROFILE_DATA = 'SET_COMPLETED_PROFILE_DATA';
export const RESET_FILTER_COMPLETED_PROFILE_DATA = 'RESET_FILTER_COMPLETED_PROFILE_DATA';


export const SET_COMPLETED_PROFILE_FILTER_DATA = 'SET_COMPLETED_PROFILE_FILTER_DATA';
export const RESET_FILTER_COMPLETED_PROFILE_FILTER_DATA = 'RESET_FILTER_COMPLETED_PROFILE_FILTER_DATA';